// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandPrimary": `#512da8`,
	"brandPrimaryHover": `#7e57c2`,
	"brandSecondary": `#7e57c2`,
	"brandSuccess": `#457c3b`,
	"brandInfo": `#5bc0de`,
	"brandWarning": `#ed6c02`,
	"brandDanger": `#d9534f`,
	"bodyBg": `#fff`,
	"baseTextColor": `#4b5563`,
	"disabledTextColor": `#969696`,
	"defaultBorderColor": `#c1c1c1`,
	"dividerBorderColor": `rgba(0,0,0,.12)`,
	"baseFont": `Roboto`,
	"fontSizeBase": `14px`,
	"borderRadius": `5px`,
	"buttonBorderRadius": `2px`,
	"buttonDefaultBackground": `#9e9e9e`,
	"buttonDefaultBackgroundHover": `#b3b2b2`,
	"buttonTextColor": `#fff`,
	"buttonFontSize": `13px`,
	"controlBorderColor": `rgba(0,0,0,.31)`,
	"controlHoverColor": `rgba(0,0,0,.14)`,
	"controlSelectionColor": `rgba(0,0,0,.08)`,
	"tableTheadBorderColor": `#e5e7eb`,
	"tableHeadBackground": `#f9fafb`,
	"switchTrackColor": `#a89bd1`,
	"chipSurfaceColor": `#50428e`,
	"chipBorderColor": `#5941c3`,
	"chipTextColor": `#fff`,
	"chipCloseColor": `hsla(0,0%,100%,.75)`
};
export default ___CSS_LOADER_EXPORT___;
